export default __webpack_public_path__ + "static/media/ic_info_warning.f5355e59.svg";